import './BugSummaryLine.css'

// One line of a bug's observed behavior under its title, cut with an ellipsis; the bug page has the rest.
export default function BugSummaryLine({ text }: { text?: string | null }) {
  const summary = text?.trim()
  if (!summary) return null
  return <span className="bug-summary-line" data-testid="bug-summary-line">{summary}</span>
}
